module.exports = __webpack_public_path__ + "static/media/blue-dimond-icon.34ece634.png";